export default "__VITE_ASSET__iv49ep$F__"